// extracted by mini-css-extract-plugin
export default {"container":"SalesStatus_container__Agr7S","container_outer":"SalesStatus_container_outer__1EKWi","label":"SalesStatus_label__GD8WD"};